var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBarlleno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63092 10.5971L9.42609 4.30526L9.3834 1.66723H9.17657L9.18614 0.00450134C4.20546 0.580235 0.336182 4.84501 0.336182 10.0229C0.336182 14.5523 3.29574 18.3837 7.37111 19.6589L7.63092 10.5971Z",
    fill: "#E84137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3096 10.0229C20.3096 4.83152 16.4212 0.557742 11.4214 0L11.4457 1.66723H11.3014L11.2661 4.30526L12.9759 10.6038L13.1069 19.7076C17.2677 18.4865 20.3096 14.6145 20.3096 10.0236V10.0229Z",
    fill: "#E84137"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.336182)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBarlleno);
export default __webpack_public_path__ + "static/media/logoBarlleno.e677aafd96c593683cf5f6b365f3745d.svg";
export { ForwardRef as ReactComponent };